import { useMemo } from 'react';

import { Box, Typography } from '@mui/material';

import { CampaignAuditResponse } from 'hooks/queries/useCampaignAudit';

import ActivityItem from '../ActivityItem';
import { flattenAndSortAuditData } from '../utils';

type Props = {
    data: CampaignAuditResponse;
    campaignName?: string;
};

/**
 * Activity list component
 * Displays a list of activity items sorted by date (newest first)
 */
const ActivityList = ({ data, campaignName }: Props) => {
    const sortedEntries = useMemo(() => flattenAndSortAuditData(data), [data]);

    if (sortedEntries.length === 0) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
                <Typography color="text.secondary">No activity found</Typography>
            </Box>
        );
    }

    return (
        <Box>
            {sortedEntries.map((entry, index) => (
                <ActivityItem
                    key={`${entry.created_at}-${entry.action}-${index}`}
                    index={index}
                    entry={entry}
                    campaignName={campaignName}
                />
            ))}
        </Box>
    );
};

export default ActivityList;
